import Shield from '@/assets/icons/shield.svg?react'
import { Text } from '@/ui-kit'

export const MissionHeader = ({ title }: { title?: React.ReactNode }) => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      {title ? title : <Text type="h4">Missions</Text>}
      <div className="flex max-w-[720px] items-center gap-5 rounded-lg border border-solid border-gray-100 px-5 py-3">
        <Shield className="shrink-0" />
        <Text type="body2-regular" className="text-wrap text-[var(--colorGray70to100)]">
          All data is anonymized and encrypted, ensuring your personal information is never exposed. You stay in control
          of what you share — and your privacy stays protected at every step.
        </Text>
      </div>
      <div className="w-[123px]" />
    </div>
  )
}
